var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0FA9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64519 11.5009L6.57956 14.625L5.70544 13.6659L7.83 11.5003L5.625 9.25425L6.56606 8.29463L9.64519 11.5009ZM11.4339 9.70594L12.375 8.74631L10.17 6.49913L12.2946 4.33406L11.4204 3.375L8.34131 6.49913L11.4339 9.70594ZM6.95644 7.9245L10.0491 11.1308L10.9901 10.1717L7.8975 7.02L6.95644 7.9245Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLend);
export default __webpack_public_path__ + "static/media/lend.7b55781d839e1abf4728d384968193e1.svg";
export { ForwardRef as ReactComponent };